import React from 'react';
import { Stack } from '@mui/material';
import ParticipantDataForm from './ParticipantDataForm';
import ParticipantDataFromOtherOrders from './ParticipantDataFromOtherOrders';

const ParticipantDetails = ({ formik }) => (
  <Stack m={2} spacing={2}>
    <ParticipantDataForm formik={formik}/>
    <ParticipantDataFromOtherOrders />
  </Stack>
);


export default ParticipantDetails;
